import { Component, OnInit } from '@angular/core';
import { LinkService } from '../typewriter/output/LinkController';
import { LinkDto } from '../typewriter/output/LinkDto';
import { LinkCategory } from '../typewriter/output/LinkCategory';

@Component({
  selector: 'app-links',
  templateUrl: './links.component.html',
  styleUrls: ['./links.component.scss']
})
export class LinksComponent implements OnInit {

  normalLinks: LinkDto[];
  preferredLinks: LinkDto[];

  constructor(
    private linkService: LinkService
  ) { }

  ngOnInit() {
    this.linkService.get()
      .then(response => {
        this.normalLinks = response.filter(l => l.category == LinkCategory.Normal);
        this.preferredLinks = response.filter(l => l.category == LinkCategory.Preferred);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/links/links.component.ts